import { fetch, postData, putData, deleteFunction } from "../../../Component/function/FunctionApi";

const ENDPOINT = "SupplierTransaction";

const buildQueryUrl = (base, params = {}) => {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      cleaned[key] = value;
    }
  });
  const query = new URLSearchParams(cleaned).toString();
  return query ? `${base}?${query}` : base;
};

const supplierTransactionService = {
  // GET /api/SupplierTransaction
  getAll: async (params = {}) => {
    const url = buildQueryUrl(ENDPOINT, params);
    return await fetch(url);
  },

  // GET /api/SupplierTransaction/{id}
  getById: async (id) => {
    return await fetch(`${ENDPOINT}/${id}`);
  },

  // GET /api/SupplierTransaction/balances
  getBalances: async () => {
    return await fetch(`${ENDPOINT}/balances`);
  },

  // POST /api/SupplierTransaction
  create: async (payload, setError = () => {}) => {
    const response = await postData(ENDPOINT, payload, setError);
    return response?.data;
  },

  // PUT /api/SupplierTransaction/{id}
  update: async (id, payload, setError = () => {}) => {
    const response = await putData(`${ENDPOINT}/${id}`, payload, setError);
    return response?.data;
  },

  // DELETE /api/SupplierTransaction/{id}
  remove: async (id) => {
    const response = await deleteFunction(`${ENDPOINT}/${id}`);
    return response?.data;
  },
};

export default supplierTransactionService;